export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/files/index/resources/computed.js